import React from 'react';
import PropTypes from 'prop-types';
import { bmPortalBooting } from './animation';
import LottieAutoPlay from '../../../../../components/Lottie/LottieAutoPlay';
import { FadeContainer } from './styledComponents';

const FadeAnimation = ({ onEnd }) => (
  <FadeContainer>
    <LottieAutoPlay
      onEnd={onEnd}
      source={bmPortalBooting}
      style={{ width: 1024, height: 576 }}
      loop={false}
    />
  </FadeContainer>
);

FadeAnimation.propTypes = {
  onEnd: PropTypes.func,
};

FadeAnimation.defaultProps = {
  onEnd: () => {},
};

export default FadeAnimation;
